var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDoctorPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_1129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_1129",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_1129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6_1129",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6_1129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5676 2.27159C11.7441 1.17355 10.4517 0.527344 9.07913 0.527344H8.92096C7.54842 0.527344 6.25601 1.17355 5.43251 2.27159C5.18184 2.60589 5.04614 3.01257 5.04614 3.43044V5.6109C5.04614 7.79463 6.81636 9.56482 9.00006 9.56482C11.1838 9.56482 12.954 7.79463 12.954 5.6109V3.43044C12.954 3.01257 12.8183 2.60589 12.5676 2.27159Z",
    stroke: "#00BCE7",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04614 5.04609C5.40776 5.04609 5.75465 4.90241 6.01037 4.64675C6.33543 4.32166 6.74067 3.91641 6.74067 3.91641C8.16295 4.62759 9.83709 4.62759 11.2594 3.91641C11.2594 3.91641 11.6647 4.32166 11.9898 4.64675C12.2455 4.90241 12.5923 5.04609 12.9539 5.04609",
    stroke: "#00BCE7",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 17.4727C17.4727 17.4727 16.7831 15.4041 16.2838 13.9061C15.9701 12.9649 15.1856 12.2574 14.2172 12.0422C12.7229 11.7101 10.6945 11.2594 10.6945 11.2594L9 14.0836L7.30547 11.2594C7.30547 11.2594 5.27709 11.7101 3.78285 12.0422C2.81443 12.2574 2.02992 12.9649 1.71619 13.9061C1.21686 15.4041 0.527344 17.4727 0.527344 17.4727",
    stroke: "#00BCE7",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30542 11.2594V9.27145",
    stroke: "#00BCE7",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6946 11.2594V9.27145",
    stroke: "#00BCE7",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8244 17.4727H11.2595V15.7781C11.2595 15.3287 11.438 14.8977 11.7558 14.5799C12.0736 14.2621 12.5046 14.0836 12.954 14.0836C13.8899 14.0836 14.6486 14.8423 14.6486 15.7781V17.4727H14.0837",
    stroke: "#00BCE7",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9539 13.5187V11.7615",
    stroke: "#00BCE7",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04618 15.2133C4.42268 15.2133 3.9165 15.7195 3.9165 16.343C3.9165 16.9665 4.42268 17.4727 5.04618 17.4727C5.66967 17.4727 6.17585 16.9665 6.17585 16.343C6.17585 15.7195 5.66967 15.2133 5.04618 15.2133Z",
    stroke: "#00BCE7",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04614 15.2133V11.7614",
    stroke: "#00BCE7",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_1129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoctorPrimary);
export default __webpack_public_path__ + "static/media/ic-doctor-primary.eff3c771e81fa85378c02e86db59d560.svg";
export { ForwardRef as ReactComponent };